// components/CalendarToolbar.jsx

import React from "react";
import { FaCalendarAlt, FaFilter, FaSyncAlt, FaThLarge } from "react-icons/fa";

import ExportEventsButton from "../ExportEventsButton";

function ActionButton({
  children,
  onClick,
  title,
  active = false,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      disabled={disabled}
      className={[
        "inline-flex min-h-10 items-center justify-center gap-2 rounded-xl border px-3 py-2",
        "text-xs font-black transition duration-200 sm:text-sm",
        "disabled:cursor-not-allowed disabled:opacity-40",
        active
          ? "border-red-600 bg-red-600 text-white shadow-md shadow-red-600/20"
          : [
              "border-slate-200 bg-white text-slate-700",
              "hover:border-red-200 hover:bg-red-50 hover:text-red-700",
              "dark:border-white/10 dark:bg-slate-900 dark:text-slate-200",
              "dark:hover:bg-red-950/30 dark:hover:text-red-300",
            ].join(" "),
      ].join(" ")}
    >
      {children}
    </button>
  );
}

export default function CalendarToolbar({
  viewMode,
  onViewModeChange,

  filtersOpen,
  activeFilterCount,

  exportEvents = [],
  canExport,
  loading,

  onOpenFilters,
  onRefresh,
}) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white p-2.5 shadow-sm dark:border-white/10 dark:bg-slate-900 sm:p-3">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div className="grid grid-cols-2 rounded-2xl bg-slate-100 p-1 dark:bg-slate-950 sm:inline-grid sm:w-auto">
          <button
            type="button"
            onClick={() => onViewModeChange("calendar")}
            className={[
              "inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4",
              "text-sm font-black transition",
              viewMode === "calendar"
                ? "bg-white text-red-600 shadow-sm dark:bg-slate-800 dark:text-red-400"
                : "text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white",
            ].join(" ")}
          >
            <FaCalendarAlt />
            Calendrier
          </button>

          <button
            type="button"
            onClick={() => onViewModeChange("cards")}
            className={[
              "inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4",
              "text-sm font-black transition",
              viewMode === "cards"
                ? "bg-white text-red-600 shadow-sm dark:bg-slate-800 dark:text-red-400"
                : "text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white",
            ].join(" ")}
          >
            <FaThLarge />
            Cartes
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <ActionButton
            onClick={onOpenFilters}
            active={filtersOpen || activeFilterCount > 0}
            title="Ouvrir les filtres"
          >
            <FaFilter />

            <span>Filtres</span>

            {activeFilterCount > 0 && (
              <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-white px-1 text-[10px] font-black text-red-600">
                {activeFilterCount}
              </span>
            )}
          </ActionButton>

          <ExportEventsButton events={exportEvents} />

          <ActionButton
            onClick={onRefresh}
            disabled={loading}
            title="Actualiser les événements"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />

            <span className="hidden sm:inline">Actualiser</span>
          </ActionButton>
        </div>
      </div>
    </div>
  );
}
